import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import Password from '../Password.js';
import PasswordStrengthIndicator from './PasswordStrengthIndicator/PasswordStrengthIndicator.js';
import PasswordStrengthRule from './PasswordStrengthRule/PasswordStrengthRule.js';
import { getPasswordStrength, containsRequiredCharacters, containsNumber, containsLowercase, containsUppercase, containsSpecialCharacter, isPasswordBelowStrengthLevel } from './utils.js';

const PasswordWithStrengthIndicator = (_param)=>{
    var { value , hasError , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "value",
        "hasError",
        "className"
    ]);
    const { getLabel  } = useIntl();
    const strength = getPasswordStrength(value);
    const isPasswordStrongEnough = ()=>!isPasswordBelowStrengthLevel(value, 'strong')
    ;
    const hasMinimumCharacters = containsRequiredCharacters(value);
    const hasOneNumber = containsNumber(value);
    const hasOneLetter = containsLowercase(value);
    const hasCapitalLetter = containsUppercase(value);
    const hasSpecialCharacter = containsSpecialCharacter(value);
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": "password-with-strength-indicator",
        className: classnames(className)
    }, /*#__PURE__*/ React.createElement(Password, swcHelpers.extends({}, rest, {
        "aria-describedby": "strength-indicator",
        required: true,
        validations: [
            isPasswordStrongEnough
        ]
    })), /*#__PURE__*/ React.createElement(PasswordStrengthIndicator, {
        showStrength: Boolean(value),
        strength: strength,
        label: getLabel(`account.passwordStrength.${strength}`)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "password-with-strength-indicator__rules"
    }, /*#__PURE__*/ React.createElement(PasswordStrengthRule, {
        label: getLabel(`account.passwordStrength.number`),
        isValid: hasOneNumber,
        highlightError: hasError
    }), /*#__PURE__*/ React.createElement(PasswordStrengthRule, {
        label: getLabel(`account.passwordStrength.lowercase`),
        isValid: hasOneLetter,
        highlightError: hasError
    }), /*#__PURE__*/ React.createElement(PasswordStrengthRule, {
        label: getLabel(`account.passwordStrength.uppercase`),
        isValid: hasCapitalLetter,
        highlightError: hasError
    }), /*#__PURE__*/ React.createElement(PasswordStrengthRule, {
        label: getLabel(`account.passwordStrength.characters`),
        isValid: hasMinimumCharacters,
        highlightError: hasError
    }), /*#__PURE__*/ React.createElement(PasswordStrengthRule, {
        label: getLabel(`account.passwordStrength.special`),
        isValid: hasSpecialCharacter,
        highlightError: hasError
    })));
};

export { PasswordWithStrengthIndicator as default };
//# sourceMappingURL=PasswordWithStrengthIndicator.js.map
